var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 32,
    viewBox: "0 0 176 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2308_3174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.0895 13.7672V15.3912H53.2495V17.18H56.8999V18.804H53.2495V22.052H51.3999V13.7672H57.0895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1357 13.7672H69.9854V22.052H68.1357V13.7672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0152 15.3672V22.052H83.1664V15.3672H80.8184V13.7672H87.36V15.3672H85.0152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.915 16.5175C104.915 17.8431 104.39 18.7023 103.338 19.0895L105.434 22.0535H103.162L101.324 19.4095H100.044V22.0535H98.1943V13.7679H101.334C102.622 13.7679 103.539 13.9855 104.09 14.4199C104.639 14.8543 104.915 15.5527 104.915 16.5175ZM102.686 17.5023C102.917 17.2967 103.031 16.9695 103.031 16.5231C103.031 16.0759 102.912 15.7703 102.675 15.6039C102.437 15.4383 102.024 15.3551 101.431 15.3551H100.045V17.8095H101.394C102.026 17.8103 102.457 17.7063 102.686 17.5023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.196 22.0535L121.425 20.2631H117.953L117.182 22.0535H115.213L118.793 13.7679H120.584L124.164 22.0535H122.196ZM119.697 16.2327L118.653 18.6399H120.725L119.697 16.2327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.937 14.8519C141.724 15.5751 142.12 16.5799 142.12 17.8703C142.12 19.1575 141.735 20.1751 140.963 20.9279C140.194 21.6775 139.018 22.0535 137.438 22.0535H134.606V13.7679H137.532C139.012 13.7671 140.145 14.1287 140.937 14.8519ZM139.581 19.7775C140.034 19.3503 140.261 18.7303 140.261 17.9159C140.261 17.1015 140.034 16.4759 139.581 16.0367C139.126 15.5991 138.427 15.3791 137.489 15.3791H136.458V20.4167H137.631C138.476 20.4167 139.124 20.2047 139.581 19.7775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.203 13.7672H155.053V22.052H153.203V13.7672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.542 20.9096C172.707 21.7272 171.674 22.136 170.45 22.136C169.226 22.136 168.195 21.7272 167.356 20.9096C166.518 20.092 166.101 19.0744 166.101 17.8568C166.101 16.6408 166.518 15.6224 167.356 14.8056C168.195 13.9888 169.225 13.5792 170.45 13.5792C171.674 13.5792 172.707 13.988 173.542 14.8056C174.38 15.6224 174.8 16.6416 174.8 17.8568C174.8 19.0744 174.38 20.0912 173.542 20.9096ZM172.915 17.8624C172.915 17.1248 172.678 16.4936 172.205 15.9728C171.729 15.452 171.148 15.1896 170.456 15.1896C169.764 15.1896 169.181 15.452 168.707 15.9728C168.233 16.4936 167.994 17.1248 167.994 17.8624C167.994 18.6016 168.233 19.2312 168.707 19.7464C169.181 20.2648 169.764 20.5232 170.456 20.5232C171.148 20.5232 171.729 20.2656 172.205 19.7464C172.678 19.2312 172.915 18.6016 172.915 17.8624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1136 26.4439V12.1559H20.5528V26.4439H16.4152V6.09595H10.856V29.2207C10.856 30.7568 12.1 32.0007 13.636 32.0007H39.9432V26.4447H26.1136V26.4439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8071 18.3104H30.2471V22.7936H35.8071V18.3104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1582 29.22C1.1582 30.756 2.4014 32 3.9382 32H5.907H6.7174V26.444V0.0407715H1.1582V29.22Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2308_3174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.31fc28254c998386ccb82d2fa0dc0bc9.svg";
export { ForwardRef as ReactComponent };